import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { DriverViewComponent } from "../driver-view/driver-view.component";
import { TruckOwnerService } from "../truck-owner.service";

@Component({
  selector: "app-truckowner-profile",
  templateUrl: "./truckowner-profile.component.html",
  styleUrls: ["./truckowner-profile.component.css"],
})
export class TruckownerProfileComponent implements OnInit {
  public cancellationImageName: string;
  loading: boolean = false;
  today = new Date();
  file: any = "";
  profileImage: any = "";
  profileView: boolean = true;
  profileEdit: boolean = false;
  token: any;
  imageCancel: any;
  profileData: any;
  profileForm: FormGroup;
  contactForm: FormGroup;
  bankForm: FormGroup;
  documentForm: FormGroup;
  emailregex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/;
  cancelled_cheque: any;
  constructor(
    private matdialogref: MatDialogRef<DriverViewComponent>,
    private services: TruckOwnerService,
    private snackBar: MatSnackBar,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    this.token = sessionStorage.getItem("to_token");
    this.getProfile();

    this.profileForm = this.formBuilder.group({
      username: ["", Validators.required],
      company_name: [""],
      mobile: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]{4,10}$"),
        ]),
      ],
      email: ["", Validators.compose([Validators.pattern(this.emailregex)])],
      dob: [""],
      gender: [""],
      profile_pic: [""],
      gst: [""],
      pan: [""],
    });
    this.contactForm = this.formBuilder.group({
      username: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[a-zA-Z0-9\\s]+$"),
        ]),
      ],
      address_line: ["", Validators.required],
      area_name: ["", Validators.required],
      city: ["", Validators.required],
      state: ["", Validators.required],
      pincode: ["", [Validators.required, Validators.pattern("^[0-9]{6,6}$")]],
      mobile: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]{4,10}$"),
        ]),
      ],
      gst: ["", Validators.required],
    });
    this.bankForm = this.formBuilder.group({
      account_name: [
        "",
        [Validators.required, Validators.pattern("^[a-zA-Z][a-zA-Z\\s]+$")],
      ],
      accountr_number: [
        "",
        [Validators.required, Validators.pattern("^[a-zA-Z][a-zA-Z\\s]+$")],
      ],
      ifsc_code: ["", Validators.required],
      bank_name: ["", Validators.required],
      branch_name: ["", Validators.required],
    });
    this.documentForm = this.formBuilder.group({
      cancelled_cheque: [""],
    });
  }
  close() {
    this.matdialogref.close();
  }
  public get ProfileFormControl() {
    return this.profileForm.controls;
  }
  public get contactFormControl() {
    return this.contactForm.controls;
  }
  public get bankFormControl() {
    return this.bankForm.controls;
  }
  public get documentFormControl() {
    return this.documentForm.controls;
  }
  editProfile() {
    this.profileView = false;
    this.profileEdit = true;
    this.ProfileFormControl["username"].setValue(this.profileData.username);
    this.ProfileFormControl["mobile"].setValue(this.profileData.mobile);
    this.ProfileFormControl["email"].setValue(this.profileData.email);
    this.ProfileFormControl["company_name"].setValue(
      this.profileData.company_name
    );
    this.ProfileFormControl["gst"].setValue(this.profileData.gst);
    this.ProfileFormControl["pan"].setValue(this.profileData.pan);
    this.ProfileFormControl["gender"].setValue(this.profileData.gender);
    this.ProfileFormControl["dob"].setValue(this.profileData.dob);
    this.contactFormControl["username"].setValue(
      this.profileData.billing_address.username
    );
    this.contactFormControl["address_line"].setValue(
      this.profileData.billing_address.address_line
    );
    this.contactFormControl["area_name"].setValue(
      this.profileData.billing_address.area_name
    );
    this.contactFormControl["city"].setValue(
      this.profileData.billing_address.city
    );
    this.contactFormControl["state"].setValue(
      this.profileData.billing_address.state
    );
    this.contactFormControl["pincode"].setValue(
      this.profileData.billing_address.pincode
    );
    this.contactFormControl["mobile"].setValue(
      this.profileData.billing_address.mobile
    );
    this.contactFormControl["gst"].setValue(
      this.profileData.billing_address.gst
    );
    this.bankFormControl["account_name"].setValue(
      this.profileData.account_details.account_name
    );
    this.bankFormControl["accountr_number"].setValue(
      this.profileData.account_details.accountr_number
    );
    this.bankFormControl["ifsc_code"].setValue(
      this.profileData.account_details.ifsc_code
    );
    this.bankFormControl["bank_name"].setValue(
      this.profileData.account_details.bank_name
    );
    this.bankFormControl["branch_name"].setValue(
      this.profileData.account_details.branch_name
    );
    this.documentFormControl["cancelled_cheque"].setValue(
      this.profileData.cancelled_cheque
    );
    this.viewImages();
  }
  updateProfile() {
    let mobile = this.profileForm.value.mobile;
    let contact_mobile = this.contactForm.value.mobile;
    Number(mobile);
    if (
      this.profileForm.valid &&
      this.contactForm.valid &&
      this.documentForm.valid
    ) {
      const profileObj = {
        username: this.profileForm.value.username,
        mobile: mobile,
        email: this.profileForm.value.email,
        dob: this.profileForm.value.dob,
        gender: this.profileForm.value.gender,
        company_name: this.profileForm.value.company_name,
        gst: this.profileForm.value.gst,
        pan: this.profileForm.value.pan,
        profile_pic: this.profileForm.value.profile_pic,
        designation: this.profileForm.value.designation,
        cancelled_cheque: this.documentForm.value.cancelled_cheque,
        billing_address: {
          username: this.contactForm.value.username,
          address_line: this.contactForm.value.address_line,
          area_name: this.contactForm.value.area_name,
          city: this.contactForm.value.city,
          state: this.contactForm.value.state,
          pincode: this.contactForm.value.pincode,
          mobile: contact_mobile,
          gst: this.contactForm.value.gst,
        },
        account_details: {
          account_name: this.bankForm.value.account_name,
          accountr_number: this.bankForm.value.accountr_number,
          ifsc_code: this.bankForm.value.ifsc_code,
          bank_name: this.bankForm.value.bank_name,
          branch_name: this.bankForm.value.branch_name,
        },
      };
      if (this.documentForm.value.cancelled_cheque == "") {
        this.snackBar.open("Please upload cancel image", "Fail", {
          duration: 5000,
        });
        return;
      }
    }
  }

  public onChange(event: any): void {
    this.file = event.target.files[0];
    this.services.uploadImage(this.file).subscribe((response: any) => {
      if (response.status === 201) {
        this.profileImage = response.body.image_link;
        this.profileForm.controls["profile_pic"].setValue(
          response.body.image_link
        );
        this.file = null;
      }
    });
  }
  public getProfile() {
    this.services.profileGet(this.token).subscribe((response: any) => {
      this.profileData = response.body.data;
      this.profileImage = response.body.data.profile_pic;
    });
  }

  public onChangeCancellation(event: any): void {
    this.file = event.target.files[0];
    this.services.uploadImage(this.file).subscribe((response: any) => {
      if (response.status === 201) {
        this.documentForm.controls["cancelled_cheque"].setValue(
          response.body.image_link
        );
        this.cancellationImageName = this.file.name;

        this.file = null;
      }
    });
  }

  viewImages() {
    let RCArray = this.profileData.cancelled_cheque.split("20");
    this.imageCancel = RCArray[2];
  }
  cancelImage() {
    this.cancellationImageName = "";
    this.documentForm.controls["cancelled_cheque"].setValue("");
  }

  validateNumber(event: KeyboardEvent) {
    const input = String.fromCharCode(event.keyCode);
    if (!/[0-9]/.test(input)) {
      event.preventDefault();
    }
  }
}
